import React from "react";
import { Link } from "react-router-dom";
import { SearchX, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({
  icon: Icon = SearchX,
  title = "Nothing found",
  description = "Try changing filters or check back soon.",
  primaryLabel,
  primaryTo,
  secondaryLabel,
  onSecondary,
  testid = "empty-state",
}) {
  return (
    <div className="rounded-2xl border border-dashed border-border bg-background px-6 py-16 text-center shadow-sm" data-testid={testid}>
      <div className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-2xl bg-gradient-to-br from-primary/15 to-primary/5 ring-1 ring-primary/10 text-primary shadow-sm animate-float-soft">
        <Icon className="h-8 w-8" />
      </div>
      <h3 className="font-display text-2xl font-black tracking-tight text-primary">{title}</h3>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">{description}</p>
      {(primaryLabel || secondaryLabel) && (
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {primaryLabel && primaryTo && (
            <Button asChild className="gap-2 font-bold" data-testid={`${testid}-primary`}><Link to={primaryTo}>{primaryLabel}<ArrowRight className="h-4 w-4" /></Link></Button>
          )}
          {secondaryLabel && (
            <Button variant="outline" onClick={onSecondary} className="font-bold" data-testid={`${testid}-secondary`}>{secondaryLabel}</Button>
          )}
        </div>
      )}
    </div>
  );
}
